import TextFilter from "./text-filter";

export default function ProjectNameFilter({projectName, setProjectName, applyFilters} : any) {    
    return (
        <TextFilter label="Project Name" text={projectName} setText={setProjectName} applyFilters={applyFilters}/>
    )
}